import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import EquipmentCard from "../EquipmentCard"
import styles from "./index.module.css"

const INITIAL_DISPLAY_COUNT = 10

const EquipmentCardList = ({
  data,
  onDeactivate,
  onActivate,
  onDelete
}) => {
  const [showAll, setShowAll] = useState(false)

  const displayData = showAll ? data : data.slice(0, INITIAL_DISPLAY_COUNT)
  const hasMore = data.length > INITIAL_DISPLAY_COUNT

  return (
    <div className={styles.container}>
      <Flex vertical gap={8} className={styles.cardList}>
        {displayData.map((equipment) => (
          <EquipmentCard
            key={equipment.key}
            equipment={equipment}
            onDeactivate={onDeactivate}
            onActivate={onActivate}
            onDelete={onDelete}
          />
        ))}
      </Flex>

      {hasMore && !showAll && (
        <div className={styles.seeMoreContainer}>
          <Button
            type="link"
            onClick={() => setShowAll(true)}
            className={styles.seeMoreButton}
          >
            See More
          </Button>
        </div>
      )}

      {data.length === 0 && (
        <div className={styles.emptyState}>
          <p>No equipment found</p>
        </div>
      )}
    </div>
  )
}

EquipmentCardList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.string,
      is_active: PropTypes.bool,
      category: PropTypes.string,
      asset_count: PropTypes.number,
      assigned_experiences: PropTypes.number,
      upcoming_bookings: PropTypes.number
    })
  ).isRequired,
  onDeactivate: PropTypes.func,
  onActivate: PropTypes.func,
  onDelete: PropTypes.func
}

export default React.memo(EquipmentCardList)
